import React from 'react';
import {Box, Card, Typography} from '@mui/material';
import {styled} from '@mui/material/styles';
import constants from "../../../../../../config/constants";

const StyledCard = styled(Card)(({ theme }) => ({
    position: 'fixed',
    bottom: "-14px",
    left: '50%',
    transform: 'translateX(-50%)',
    width: '80%',
    maxWidth: 800,
    zIndex: 1300,
    height: "50px",
    padding: "16px",
    boxShadow: '0 -4px 20px rgba(0, 0, 0, 0.3)',
    borderRadius: '16px 16px 0 0',
}));

const ResourceItem = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: "100%",
    flex: 1,
}));

const ResourceIcon = styled('img')({
    width: "auto",
    height: '100%',
    flex: 1,
    objectFit: 'contain',
});

export const ResourcesComponent = ({player, gameId}) => {

    if(!player.privateFields || player.privateFields.length === 0){
        return undefined;
    }
    const baseImageUrl = constants.api.basePath + "/generated/" + gameId + "/image";

    return (
        <StyledCard>
            <Box display="flex" width="100%" justifyContent="center" alignItems="center" height="100%" gap={4}>
                {player.privateFields.map((field) => (
                    <ResourceItem key={field}>
                        <ResourceIcon
                            src={`${baseImageUrl}?imagePath=icon_${field}.png`}
                            alt={field}
                        />
                            {player[field]}
                    </ResourceItem>
                ))}
            </Box>
        </StyledCard>
    );
}